import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Tutorial_Fernzugriff_per_Portweiterleitung_D_Link.mp4" />
        </Player>
        <EuiText>
            <p>Eine Portweiterleitung einrichten bei einem D-Link Router. Auf <OutboundLink href="https://www.youtube.com/watch?v=VVMxEgbi9Vo" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard